export enum ContactLabel {
    Work="Work",
    Personal="Personal",
    Other="Other",
}